import { HsvaColor } from '@uiw/color-convert';

import { ColorCombinationEnum, CombinatedColorsType } from '../types';

export enum ExportStatusEnum {
  READY_TO_START,
  STARTED,
  DONE,
}

export enum ActionTypesEnum {
  SET_MAIN_COLOR_COMBINATION,
  GO_PREV_VERSSION,
  GO_NEXT_VERSSION,
  ADD_APP_STATE,
  SET_COLOR_COMBINATION,
  SET_HSVA_ALPHA,
  SET_EXPORT_STATUS,
}

export interface IStateModel {
  exportStatus: ExportStatusEnum;
  mainColorCombination: CombinatedColorsType;
  colorCombination: ColorCombinationEnum;
  appState: {
    mainColorCombination: CombinatedColorsType;
    colorCombination: ColorCombinationEnum;
    hsvaAlphaMain: HsvaColor;
  }[];
  appStateVersion: number;
  hsvaAlphaMain: HsvaColor;
}

export interface IActionModel {
  type: ActionTypesEnum;
  payload?: any;
}
